module.exports = __webpack_public_path__ + "media/images/uncdf-c728a03ece382d7b2526f83edfab5f16.png";